var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"p-2 filter transition-all hover:brightness-125"},[_c('i',{domProps:{"innerHTML":_vm._s(_vm.$icons.kebab)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }